window.VariationsWidget ?= {}
VariationsWidget.Views ?= {}

VariationsWidget.Views.Option = Backbone.View.extend
  initialize: ->
    _.bindAll this, 'render'
    @model.bind 'change:disabled', @render

    if VariationsWidget.printSoldOut
      @model.bind 'change:forceDisplay', @render
    if VariationsWidget.printOptionPrice
      @model.bind 'change:optionPrice', @render
      @model.bind 'change:selected', @render

  render: ->
    @$el.attr 'disabled', @model.get('disabled')

    @clearSoldOut()

    if VariationsWidget.printSoldOut and @model.get('disabled')
      @renderSoldOut()
    if VariationsWidget.printOptionPrice
      @renderPrintOptionPrice()

  clearSoldOut: ->
    @$el.removeClass('force-display')
    @$el.find('.sold-out-text').remove()

    return

  renderSoldOut: ->
    return unless @model.get('forceDisplay')

    soldOutText = I18n?.t('js.modules.variations.sold_out')
    string = "<span class=\"sold-out-text\">#{soldOutText}</span>"

    @$el.addClass('force-display')
    @$el.prepend(string)
    return

  renderPrintOptionPrice: ->
    optionPrice = @model.get('optionPrice')
    isSelected = @model.get('selected')
    string = "<span class=\"option-price\">(#{optionPrice})</span>"
    @$el.find('.option-price').remove()

    if optionPrice and not isSelected
      @$el.append(string)

module.exports = VariationsWidget.Views.Option



// WEBPACK FOOTER //
// ./modules/variations/frontend/views/option.coffee